var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar4 = function SvgDefaultAvatar4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9 55.3c2.1 0 2.4-.3 2.4-1.3v-5.3h2.8c1.6 0 2.1-.3 2.1-1.9 0-1.5-.5-1.9-2.1-1.9h-2.8V27.1c0-1.3-.8-2.1-2.3-2.1-2 0-2.7 1-4 2.6-3.5 4.8-7 10.3-10.2 15.8-.6 1.1-1.4 2.3-1.4 3.4 0 1.2.8 1.9 2.1 1.9h10.9V54c.1.9.4 1.3 2.5 1.3zM31.8 44.9c3.1-5.3 6.4-10.6 9.8-15.4v15.4h-9.8z"
  })));
};
export default SvgDefaultAvatar4;